import { Component } from '@angular/core';

@Component({
    selector: 'redispatch-netzzuordnungen-page',
    templateUrl: './netzzuordnungen-page.component.html',
    styleUrls: [
        './netzzuordnungen-page.component.scss',
    ],
    standalone: false,
})
export class NetzzuordnungenPageComponent {
}
